// Open a new tab with the given URL
export const openInNewTab = (url: string) => {
  if (typeof window === "undefined") return;
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};
